var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"myApp"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('custom-alert'),_c('form-modal',{attrs:{"form":_vm.formChangePassword,"data-source":{cuit: _vm.cuit},"open":_vm.modalChangePassword},on:{"update:open":function($event){_vm.modalChangePassword=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }